import React from 'react';
import styles from './PageHeader.module.css';

// SCRUM-450: the one page-title style used by every admin page. Page CSS
// modules used to each declare their own bare `h2 { … }` rule — an element
// selector isn't scoped by CSS modules, so the last-loaded page's rule won
// and styled every other page's title too. This component is the only place
// a page title is styled; page CSS modules must not touch h1/h2 again.
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
